import React from 'react';
import axios from '../../../config/axiosConfig';
import { ERROR_RESPONSE } from '../../../shared';
import { TEST_LAUNCH_RESULT } from './TestCodeButton.constants';
import { TestLaunchRequest, TestLaunchResult, ValidateTestResult } from './TestCodeButton.interfaces';
import { TEST_TAKER_TYPE } from './TestCodeButton.types';

/**
 * validate user input
 * @param {string} char : The character from the input event the user just fired
 * @returns {boolean} isValid : dictates whether the user input is registered or not
 */
export const isInputValid = (char: string|null): boolean => {
  let isValid = true;
  if (char) {
    isValid = !!char.match(/[a-zA-Z0-9]/);
  } else {
    isValid = false;
  }
  return isValid;
};

/**
 *
 * @param testCode test ticket alphanumeric string in the form: XXX-XXX
 * @returns {boolean} isValid : dictates whether test code has valid form
 */
export const isTestCodeValid = (testCode: string): boolean => {
  if (!testCode || testCode.length !== 7) {
    return false;
  }

  const [firstHalf, secondHalf] = testCode.split('-');

  if (firstHalf.length !== 3 || secondHalf.length !== 3) {
    return false;
  } else {
    const testTicketCode = firstHalf + secondHalf;
    return !!testTicketCode.match(/[a-zA-Z0-9]/);
  }
};

/**
 *
 * @param {string} testCode alphanumeric string: XXX-XXX
 * @param setUserInput useState setter
 * @param setTestCode useState setter
 * @param setCursor useState setter
 * @param setIsDisabled useState setter
 */
export const setTestCodeManually = (
  testCode: string,
  setUserInput: React.Dispatch<React.SetStateAction<string[]>>,
  setTestCode: React.Dispatch<React.SetStateAction<string>>,
  setCursor: React.Dispatch<React.SetStateAction<number>>,
  setIsDisabled: React.Dispatch<React.SetStateAction<boolean>>
): void => {
  const testCodeArray = testCode.split('');
  testCodeArray.splice(3,1);
  setUserInput(testCodeArray);
  setTestCode(testCode);
  // setCursor(7);
  setIsDisabled(false);
};


export const validateTestCodeAsync = async(
  testTicket: string,
  testTakerType: TEST_TAKER_TYPE
): Promise<ValidateTestResult> => {
  const request = {testTicket, testTakerType} as TestLaunchRequest;
  const response = await axios.post<ValidateTestResult>( 'api/testLaunch/validate', request)
    .then( res => res.data)
    .catch( (errMsg: string): ValidateTestResult => ({
      testTakerResultID: -1,
      startTestLabel: '',
      startTestURL: '',
      errMsg
    }));
  return response;
};

export const launchTestAsync = async(
  testTakerResultID: number
): Promise<TestLaunchResult> => {
  const response = await axios.post<TestLaunchResult>(
    'api/testLaunch/launch',
    testTakerResultID,
    {
      headers: {
        'content-type': 'application/json'
      }
    }
  )
    .then( res => ({...res.data, testTakerResultID, __typename: TEST_LAUNCH_RESULT}))
    .catch( (err: string): TestLaunchResult => ({
      __typename: ERROR_RESPONSE,
      administrationID: -1,
      numQuestions: -1,
      testID: -1,
      testTakerResultID,
      startTestURL: '',
      errMsg: err.toString()
    }));
  return response;
};